import moment from 'moment';

const workSchedules = [
  {
    label: 'Última Semana',
    value: [
      moment()
        .subtract(1, 'weeks')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: 'Quincena',
    value: [
      moment()
        .subtract(15, 'days')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: 'Mes Anterior',
    value: [
      moment()
        .subtract(1, 'months')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: '12 meses',
    value: [
      moment()
        .subtract(1, 'years')
        .format('L'),
      moment().format('L')
    ]
  }
];

const twentyFourMonths = [
  {
    label: '24 meses',
    value: [
      moment()
        .subtract(2, 'years')
        .format('L'),
      moment().format('L')
    ]
  }
];

const informesWorkSchedules = [
  {
    label: 'Semanal',
    value: [
      moment()
        .subtract(1, 'weeks')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: 'Quincenal',
    value: [
      moment()
        .subtract(15, 'days')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: 'Mensual',
    value: [
      moment()
        .subtract(1, 'months')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: 'Anual',
    value: [
      moment()
        .subtract(1, 'years')
        .format('L'),
      moment().format('L')
    ]
  }
];

const workSchedulesTypes = [
  { label: 'Todos', value: 'all' },
  { label: 'Jornada Completa', value: 'full_time' },
  { label: 'Jornada Parcial', value: 'part_time' },
  { label: 'Articulo 22', value: 'article_22' }
];

export { workSchedulesTypes, workSchedules, informesWorkSchedules, twentyFourMonths };
